export default {
  'Watermark': 'Filigrane',
  'Add Watermark Selection': 'Ajouter une sélection de filigranes',
}